import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import axios from 'axios';
import { UpdatefirebaseService } from '../../services/updatefirebase.service';

@Component({
  selector: 'app-grouprepair',
  templateUrl: './grouprepair.component.html',
  styleUrls: ['./grouprepair.component.css']
})
export class GrouprepairComponent implements OnInit , OnDestroy {

  FormCutGroup:UntypedFormGroup;
  constructor(private firebase:UpdatefirebaseService) {
    this.FormCutGroup = new UntypedFormGroup({
      fmdata: new UntypedFormControl(), 
      groupnameedit: new UntypedFormControl(),
      groupcodeedit: new UntypedFormControl(),
      timecut: new UntypedFormControl(),
      selectconfirm: new UntypedFormControl(),
    });
    this.LoadGCut();
    this.LoadRepair();
   }

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
      this.fmlist = null;
      this.gcut = null;
      this.grepair = null;
  }

  // โหลดข้อมูลแปลง
  fmlist:any;
  LoadDatabyFmcode(){
    let data = (this.FormCutGroup.get('fmdata').value).trim();
    let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_cp_data_w?year=2223&fmcode="+data;
    axios
    .get(url)
    .then(response => {
      this.fmlist =  response.data.recordset;
    })
    .catch(err => {
      throw (err)
    })
  }

  // โหลดกลุ่มตัด 
  gcut:any;
  LoadGCut(){
    let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_groupCode_HM_w?status=1&category=H";
    axios
    .get(url)
    .then(response => {
      this.gcut =  response.data.recordset;
    })
    .catch(err => {
      throw (err)
    })
  }

   // โหลดกลุ่มตัด 
   grepair:any;
  LoadRepair(){
     let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_groupCode_HM_w?status=1&category=M";
     axios
     .get(url)
     .then(response => {
       this.grepair =  response.data.recordset;
     })
     .catch(err => {
       throw (err)
     })
   }
  // อัพเดทกลุ่มตามเงื่อนไข
  Updategroupdata(id:any,key:any,code:any){
    if(id ==1){
      setTimeout(() => {
        this.LoadDatabyFmcode();
      }, 2500);
    }
    else {
      setTimeout(() => {
        this.LoadDatabyFmcode();
      }, 2500);
    }
  }

}
